<template>
  <ProductForm
    :product="$store.state.products.product"
    :onSubmit="submit"
  ></ProductForm>
</template>

<script>
import ProductForm from './ProductForm.vue';
import { busEvent } from '../../main';
import { mapActions } from 'vuex';

export default {
  name: 'CreateProduct',
  components: {
    ProductForm,
  },
  methods: {
    ...mapActions('products', ['create']),
    async submit() {
      await this.create();
      busEvent.$emit('succesPopupCreated', 'Produsul a fost creat');
      this.$router.push({ path: '/products' });
    },
  },
};
</script>
